import React, { useState, useEffect, useRef } from 'react';
import Card from '@mui/material/Card';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import Carousel from 'react-material-ui-carousel';
import { Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
import EditionCard from './EditionCard';
import FindUserMap from './FindUserMap';
import AddImageCard from './AddImageCard';
import SportsMotorsportsIcon from '@mui/icons-material/SportsMotorsports';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import axios from 'axios';  // Import axios
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const SearchResultCard = ({ onSearch, deliveryPoint, onClose }) => {
    // Move the destructured data into state so it can be updated dynamically
    const [deliveryData, setDeliveryData] = useState(deliveryPoint);

    const { id, user_id, driver_id, recipient_phone, charge, charged, notes_driver, transfer, transfer_client, status, recipient_name, address, image_urls, notes, latitude, longitude, sequence, district, arrival_time } = deliveryData;
    const [position, setPosition] = useState([latitude || -12.0464, longitude || -77.0428]);
    const initialZoom = 14
    
    const customIcon = L.icon({
        iconUrl: `${process.env.PUBLIC_URL}/logo.png`,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
      });

      function ChangeView({ center, zoom }) {
        const map = useMap();
        map.setView(center, zoom);
        return null;
      }

      useEffect(() => {
        setPosition([latitude || -12.0464, longitude || -77.0428]);
      }, [latitude, longitude]);

    const [showEditionCard, setShowEditionCard] = useState(false);
    const [showMapUserCard, setShowMapUserCard] = useState(false);
    const [showAddImageCard, setShowAddImageCard] = useState(false);

    const defaultImages = [
        `${process.env.PUBLIC_URL}/moto2.png`,
    ];

    const images = image_urls && image_urls.length > 0 ? image_urls : defaultImages;

    // Fetch updated delivery point data every 3 seconds
    useEffect(() => {
        const fetchUpdatedDeliveryPoint = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/search/delivery_point`, {
                    params: { entrega_id: id }
                });

                if (response.status === 200) {
                    setDeliveryData(response.data); // Update the delivery data state
                }
            } catch (error) {
                console.error('Error fetching updated delivery point:', error);
            }
        };

        // Set interval to fetch data every 3 seconds
        const intervalId = setInterval(fetchUpdatedDeliveryPoint, 3000);

        // Cleanup the interval on component unmount
        return () => clearInterval(intervalId);
    }, [id]);  // Run only when the `id` changes

    const handleUserClick = async () => {
        let response;

        response = await axios.get(`${process.env.REACT_APP_API_URL}/api/search/user`, {
            params: { id: user_id },
        });
        onSearch(response.data, 'user');
    };


    const handleEditClick = () => {
        setShowEditionCard(true);
    };

    const peruNow = dayjs().tz("America/Lima");
    const deliveryDate = dayjs(deliveryData.delivery_date); // Assuming ISO string

    // deliveryDate is same day
    const isToday = deliveryDate.isSame(peruNow, 'day');
    // deliveryDate is in the future
    const isFuture = deliveryDate.isAfter(peruNow, 'day');

    // 12:30 pm cutoff
    const cutoffTime = dayjs()
    .tz("America/Lima")
    .hour(12)
    .minute(45)
    .second(0);

    // Determine if button should be active
    const canEdit = isFuture || (isToday && peruNow.isBefore(cutoffTime));

    const handleCloseEditionCard = () => {
        setShowEditionCard(false);
    };

    const handleFindUserMapClick = () => {
        setShowMapUserCard(true);
    };

    const handleCloseFindUserMapCard = () => {
        setShowMapUserCard(false);
    };

    const handleCloseAddImageCard = () => {
        setShowAddImageCard(false);
    };

      

    

    const handleWhatsAppClick = () => {
        window.open(`https://wa.me/51${deliveryData.recipient_phone}`, '_blank');
    };

    const handleChangeDriverClick = (deliveryPointId) => {
            // Prompt the user for the new driver ID
            const newDriverId = prompt("Por favor, ingresa el nuevo ID del conductor:", "");
        
            // If the user cancels or enters nothing, exit the function
            if (newDriverId === null || newDriverId.trim() === "") {
                alert("Operación cancelada o ID no válido.");
                return;
            }
        
            // Proceed with the API call if a valid ID was entered
            axios.post(`${process.env.REACT_APP_API_URL}/api/update/driver_id`, {
                id: deliveryPointId,  // The delivery point ID
                driver_id: newDriverId.trim()  // The new driver ID, trimmed for extra spaces
            })
            .then(response => {
                alert("El conductor ha sido actualizado exitosamente.");
                // Optionally, update the UI or trigger a state refresh here
            })
            .catch(error => {
                console.error('Error updating driver:', error);
                alert('No se pudo actualizar el conductor.');
            });
        };

    

    

    const formatArrivalTime = (time) => {
        const date = new Date(time);
        const hour = date.getHours() - 5;
        const minutes = date.getMinutes().toString().padStart(2, '0');
        
        // Calculate the time range (±1 hour)
        const startHour = (hour - 0 + 24) % 24; // To handle negative hours
        
        
        return `${startHour}:${minutes}`;
    };

    return (
        <Box sx={{ position: 'relative' }}>
            <Card sx={{ maxWidth: 600, position: 'relative', top: "80px", left: "10px", zIndex: '2000' }}>
                <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    {recipient_name.length > 25 ? `${recipient_name.substring(0, 25)}...` : recipient_name} {id} {status}
                </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2" color="text.secondary">
                        {address.length > 25 ? `${address.substring(0, 25)}...` : address}, 
                        {charge}
                    </Typography>
                        <Box>
                            <IconButton size="small" onClick={() => handleChangeDriverClick(id)}>
                                <SportsMotorsportsIcon />
                            </IconButton>

                            <IconButton size="small" onClick={handleUserClick}>
                                <PersonIcon />
                            </IconButton>
                            
                            <IconButton size="small" onClick={canEdit ? handleFindUserMapClick : undefined} disabled={!canEdit}>
                                <InfoIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                        {notes.length > 25 ? `${notes.substring(0, 25)}...` : notes} {transfer ? 'Transferencia: Si' : transfer_client ? 'Transferencia a Cliente: Si' : 'No Transfer Info'}, {charged}
                        </Typography>
                        <Box>

                    
                            <IconButton size="small" onClick={canEdit ? handleEditClick : undefined} disabled={!canEdit}>
                                <EditIcon />
                            </IconButton>
                    
                            <IconButton size="small" onClick={handleWhatsAppClick}>
                                <WhatsAppIcon />
                            </IconButton>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                            {district} {recipient_phone} {sequence}  {driver_id} {notes_driver} {formatArrivalTime(arrival_time)}
                        </Typography>
                    
                    </Box>
                </CardContent>

                <Box sx={{ display: 'flex', flexDirection: 'row', height: '320px', marginTop: 2 }}>
                    <Box sx={{ width: '35%', height: '100%' }}>
                        <Carousel>
                            {images.map((image, index) => (
                                <CardMedia
                                    key={index}
                                    component="img"
                                    alt={`${recipient_name} image ${index + 1}`}
                                    height="320"
                                    image={image}
                                />
                            ))}
                        </Carousel>
                    </Box>
                    <Box sx={{ width: '65%', height: '100%' }}>
                    <MapContainer center={position} zoom={initialZoom} style={{ width: '100%', height: '100%' }} zoomControl={false}>
                        {/* Using OpenStreetMap tile layer */}
                        <TileLayer
                        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={position} icon={customIcon}>
                        <Popup>
                        Entrega aqui
                        </Popup>
                        </Marker>
                        <ChangeView center={position} zoom={initialZoom} />
                    </MapContainer>
                    </Box>
                </Box>

                <IconButton
                    size="medium"
                    onClick={onClose}
                    style={{ position: 'absolute', top: 7, right: 7, backgroundColor: 'white', zIndex: 1 }}
                >
                    <CloseIcon />
                </IconButton>
            </Card>

            {showEditionCard && (
                <EditionCard deliveryPoint={deliveryData} onClose={handleCloseEditionCard} />
            )}
            {showMapUserCard && (
                <FindUserMap onClose={handleCloseFindUserMapCard} deliveryId={id} />
            )}
            {showAddImageCard && (
                <AddImageCard deliveryId={id} onClose={handleCloseAddImageCard} />
            )}
        </Box>
    );
};

export default SearchResultCard;
